import { render } from "./SideDrawer.vue?vue&type=template&id=02970425&scoped=true"
import script from "./SideDrawer.vue?vue&type=script&lang=js"
export * from "./SideDrawer.vue?vue&type=script&lang=js"

import "./SideDrawer.vue?vue&type=style&index=0&id=02970425&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02970425"]])

export default __exports__